module.exports = __webpack_public_path__ + "static/media/how-it-works-splash.f1700c1a.jpg";